

export const getters = {
  getTypeList: state => {
    return state.typeList;
  },
  getCategoryList: state => {
    return state.categoryList;
  },
  getCategoryListExcludingSelectedCategory: state => {
    return state.categoryListExcludingSelectedCategory;
  },
  getSelectedCategory: state => {
    return state.selectedCategory;
  },
  getUomList: state => {
    return state.uomList;
  },
  getSelectedUom: state => {
    return state.selectedUom;
  },
  getUomLookup: (state) => (id) => {
    return state.uomList.filter((uom) => uom.id == id)
  },
  getCategoryGroupsList: state => {
    return state.categoryGroupsList;
  },
  getSelectedCategoryGroups: state => {
    return state.selectedCategoryGroups;
  },
  getTemplatesList: state => {
    return state.templatesList;
  },
  getSelectedTemplate: state => {
    return state.selectedTemplate;
  },
}
